import { PolicyAntiFraud } from 'src/types'

export default function sanitizeToPost(
  values: PolicyAntiFraud
): PolicyAntiFraud {
  delete values.organization
  delete values.policy_rule
  values.organization_id = +values.organization_id || null
  values.policy_request_receipt_antifraud_id =
    +values.policy_request_receipt_antifraud_id || null
  values.policy_rule_id = +values.policy_rule_id || null
  return values
}
